export const getMailtoLink = (email = '') => `mailto:${email}`;
